import * as React from 'react';
import ReactGA from 'react-ga4';
import CssBaseline from '@mui/material/CssBaseline';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from '../components/generic/AppAppBar';
import Footer from '../components/generic/Footer';
import { Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { baseUrl } from '../Constants';

const Layout = (props) => {
    ReactGA.initialize('G-HMH34C3EJH');
    localStorage.setItem('mui-mode', 'dark');
    React.useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    }, []);
    const location = useLocation();

    return (
        <AppTheme {...props}>
            <Helmet>
                <link rel="canonical" href={`${baseUrl}${location.pathname}`} />
            </Helmet>
            <CssBaseline enableColorScheme />
            <AppAppBar />
            <Outlet />
            <Footer />
        </AppTheme>
    )
}

export default Layout;